<template>
  <keep-alive>
    <component
      ref="mediaLdr"
      v-if="isReady"
      :is="componentLoader"
      :propFileId="propFileId"
      :prms="prms"
      :minusHeight="minusHeight"
      @on-completed-info="$emit('on-completed-info', $event)"
      @on-finish-video="$emit('on-finish-video', $event)"
      @on-hide-finish-btn="$emit('on-hide-finish-btn', $event)"
      :force="force"
      @on-img-loaded="$emit('on-img-loaded', $event)"
      @on-interactive-media="$emit('on-interactive-media', $event)"
      @on-interactive-html="$emit('on-interactive-html', $event)"
    ></component>
  </keep-alive>
</template>

<script>
export default {
  name: "filepreview",
  props: {
    otCompName: {
      type: String,
      default: () => null
    },
    propFileId: {
      type: Number,
      default: () => null
    },
    prms: {
      type: Object,
      default: () => {}
    },
    minusHeight: {
      type: Number,
      default: () => 115
    },
    force: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      isReady: false
    };
  },
  mounted() {
    //console.log('step 99', this.otCompName);
    if (this.$props.otCompName) {
      this.loadComponent();
    }
  },
  computed: {
    componentLoader() {
      //console.log();
      return () =>
        import(`@/components/modules/media/components/${this.otCompName}`);
    }
  },
  methods: {
    loadComponent() {
      this.isReady = true;
      this.componentLoader();
    },
    playerResume(){
      this.$refs.mediaLdr.playerResume();
    },
  }
  // beforeDestroy() {
  //   this.isReady=false;
  // }
};
</script>
